import type { ReactNode } from 'react'
import { publicConfig } from 'config'
import { ViewerDevicesContext } from 'shared-components/contexts/ViewerDevicesContext'
import { useMyDevices } from 'lib/devices/MyDevicesContext'

/**
 * Hands the reader's own phone state to the comments widget's phone pill (packages'
 * ViewerDevicesContext, Directive 2fe85266c: provided where the app's device state lives).
 * `viewerHasPhone` is null until the devices read is ready — only a known `false` draws "Add your
 * phone"; the widget's own "Hide on comments" writes, then `onDevicesChanged` re-reads ours.
 */
export const ViewerDevicesBridge: React.FC<{ children: ReactNode }> = ({ children }) => {
  const devices = useMyDevices()
  return (
    <ViewerDevicesContext.Provider
      initialState={{
        viewerHasPhone: devices.status === 'ready' ? devices.current !== null : null,
        onDevicesChanged: devices.reload,
        siteName: publicConfig('siteName'),
      }}
    >
      {children}
    </ViewerDevicesContext.Provider>
  )
}
